import { DetailRow } from '../SubscriptionDetails/components/index';
import React from 'react';

type Props = {
  label: string;
  referalCode: string;
};
export const SubscriptionReferalCode = ({ label, referalCode }: Props) => {
  return (
    <DetailRow
      label={{
        value: label,
      }}
      value={{
        value: referalCode,
        color: 'black.main',
        fontWeight: 0,
      }}
    />
  );
};
